import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Table } from 'antd';
import { useReportByEmployee } from '@/app/time-tracking/_shared/hooks';
import { PaginationControls } from '@/components/data-table/PaginationControls';
import ExpandedEntries from './ExpandedEntries';
import { getEmployeeColumns } from './ReportColumns';

export default function ReportByEmployee({
  filters,
  offset = 1,
  limit = 10,
  onPaginationChange,
  searchParams,
  updateParams,
}) {
  const { t } = useTranslation('forms');
  const { data: response, isLoading } = useReportByEmployee(filters);
  const rows = response?.data || [];
  const total = response?.total || 0;

  const columns = useMemo(
    () => getEmployeeColumns({ searchParams, updateParams, t }),
    [searchParams, updateParams, t]
  );

  return (
    <Table
      columns={columns}
      dataSource={rows}
      rowKey={(r) => r.employee?._id}
      loading={isLoading}
      className="ant-table-content"
      pagination={
        total > limit
          ? {
              current: offset,
              pageSize: limit,
              total,
              onChange: onPaginationChange,
              showSizeChanger: false,
              showQuickJumper: false,
              position: ['bottomCenter'],
              itemRender: (page, type, originalElement) => (
                <PaginationControls
                  type={type}
                  originalElement={originalElement}
                />
              ),
            }
          : false
      }
      expandable={{
        expandedRowRender: (record) => (
          <ExpandedEntries
            filters={filters}
            groupBy="employee"
            groupId={record.employee?._id}
            isAdmin
            showProject
          />
        ),
      }}
    />
  );
}
